import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { FormContainer } from '../Form'
import { isEmptyString} from '../../../../../../helpers/sanityChecks'
import { validateFields } from '../../../../../../helpers/collaborativeIndexations'
import { NameContainer } from '../Commons/Name'

class NominativeForm extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.formSteps = [
            () => <NameContainer hasFocus={true}/>,
        ]

        this.formStepsValidation = {
            2: () => {
                validateFields({
                    lastname: () => ! isEmptyString(this.props.fields.lastname),
                })
            }
        }
    }

    render()
    {
        return (
            <FormContainer steps={ this.formSteps } stepsValidation={ this.formStepsValidation } />
        )
    }
}

export default withTranslation()(NominativeForm)
